var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2811,
    y: 67.0366,
    width: 7.48166,
    height: 11.8826,
    fill: "#E65C5C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.11,
    y: 58.9683,
    width: 7.48166,
    height: 19.9511,
    fill: "#F8D20D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6724,
    y: 64.5427,
    width: 7.48166,
    height: 14.3765,
    fill: "#80D6FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2347,
    y: 52.8069,
    width: 7.48166,
    height: 26.1125,
    fill: "#98CA69"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3472,
    y: 78.9192,
    width: 43.7164,
    height: 3.08068,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3472,
    y: 44.5918,
    width: 20.2445,
    height: 3.08068,
    fill: "#92BBEC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3472,
    y: 50.6064,
    width: 11.5892,
    height: 3.08068,
    fill: "#92BBEC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6602,
    y: 26.1074,
    width: 17.7506,
    height: 3.08068,
    fill: "#92BBEC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 51.0856,
    y: 26.1074,
    width: 2.93399,
    height: 3.08068,
    fill: "#92BBEC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9388,
    y: 31.8289,
    width: 2.93399,
    height: 3.08068,
    fill: "#92BBEC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 51.0856,
    y: 37.55,
    width: 2.93399,
    height: 3.08068,
    fill: "#92BBEC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6602,
    y: 31.8289,
    width: 17.7506,
    height: 3.08068,
    fill: "#92BBEC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6602,
    y: 37.6968,
    width: 17.7506,
    height: 3.08068,
    fill: "#92BBEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2445 33.4426C46.2445 35.01 45.8328 36.5499 45.0506 37.9082C44.2684 39.2666 43.1431 40.3956 41.7874 41.1823C40.4317 41.9691 38.8931 42.3859 37.3257 42.3912C35.7583 42.3964 34.217 41.9898 32.856 41.2122L37.2958 33.4426H46.2445Z",
    fill: "#FFE352"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5079 24.7738C35.9612 24.3 37.5118 24.2064 39.0116 24.5019C40.5115 24.7974 41.9106 25.4722 43.0756 26.4619C44.2406 27.4517 45.1326 28.7234 45.6666 30.1557C46.2006 31.5881 46.3588 33.1334 46.1261 34.6443L37.2817 33.2817L34.5079 24.7738Z",
    fill: "#80D6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3197 32.5496C28.4938 30.674 29.2554 28.9012 30.4958 27.4836C31.7363 26.0661 33.3924 25.0762 35.2283 24.6548L37.2301 33.3767L28.3197 32.5496Z",
    fill: "#766CEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8629 41.2114C31.333 40.3418 30.0934 39.0403 29.2993 37.4698C28.5052 35.8994 28.1918 34.1296 28.3982 32.3819L37.2851 33.4318L32.8629 41.2114Z",
    fill: "#EE5555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditReport);
export default __webpack_public_path__ + "static/media/audit-report.311f4cd71e69aba8ccae7f0bf03a4254.svg";
export { ForwardRef as ReactComponent };